import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./ActivityLegendStyles";
import Toggle from "react-toggle";

export default class ActivityLegend extends Component {
  handleToggle = (e) => {
    this.props.onChange(e.target.checked);
  };
  render() {
    return (
      <div className={css(styles.legend)}>
        <div
          className={css([
            styles.legendWrapper,
            !this.props.offAlertsHidden && styles.legendWrapperGreyscale,
          ])}
        >
          <span className={css(styles.legendPanel)}>
            <svg viewBox="0 0 34 34" className={css(styles.svg)}>
              <rect
                x="0"
                y="0"
                width="34px"
                height="34px"
                rx="3px"
                ry="3px"
                fill={"#00C5FF"}
              />
            </svg>
            <p className={css(styles.legendLabel)}>Normal Activity</p>
          </span>
          <span className={css(styles.legendPanel)}>
            <svg viewBox="0 0 34 34" className={css(styles.svg)}>
              <rect
                x="0"
                y="0"
                width="34px"
                height="34px"
                rx="3px"
                ry="3px"
                fill={"url(#warningHash)"}
              />
            </svg>
            <p className={css(styles.legendLabel)}>On Alert Warning</p>
          </span>
          <span className={css(styles.legendPanel)}>
            <svg viewBox="0 0 34 34" className={css(styles.svg)}>
              <rect
                x="0"
                y="0"
                width="34px"
                height="34px"
                rx="3px"
                ry="3px"
                fill={"url(#urgentHash)"}
              />
            </svg>
            <p className={css(styles.legendLabel)}>On Alert Urgent</p>
          </span>
        </div>

        <div className={css(styles.offWrapper)}>
          <span className={css([styles.legendPanel, styles.offWrapperPanel])}>
            <div className={css(styles.offWrapperIcon)}>
              <svg viewBox="0 0 34 34" className={css(styles.svg)}>
                <rect
                  x="0"
                  y="0"
                  width="34px"
                  height="34px"
                  rx="3px"
                  ry="3px"
                  fill={"url(#offHash)"}
                />
              </svg>
              <p className={css(styles.legendLabel)}>
                {this.props.offAlertsNumber ? this.props.offAlertsNumber : "No"}{" "}
                Off Alert
                {this.props.offAlertsNumber !== 1 ? "s" : ""}
              </p>
            </div>
            {this.props.offAlertsNumber > 0 && (
              <div>
                <h3 className={css(styles.breakdownTitle)}>
                  <div className={css(styles.breakdownToggle)}>
                    <span className={css(styles.breakdownToggleUnit)}>
                      Show
                    </span>
                    <label className={css(styles.breakdownToggleLabel)}>
                      <Toggle
                        defaultChecked={this.props.offAlertsHidden}
                        icons={false}
                        onChange={(e) => this.handleToggle(e)}
                      />
                    </label>
                    <span className={css(styles.breakdownToggleUnit)}>
                      Hide
                    </span>
                  </div>
                </h3>
              </div>
            )}
          </span>
        </div>
      </div>
    );
  }
}
